import AgreementsDocumentVersion from './AgreementsDocumentVersion'
import { BaseModel, convertToArrayModels, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class AgreementsDocument extends BaseModel {
  static override constructorName = 'AgreementsDocument'

  id: string = ''
  title: string = ''
  code: string = ''
  isRequired: boolean = false
  versions: Array<AgreementsDocumentVersion> = []
  actualVersion: AgreementsDocumentVersion | null = null

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['versions', 'actualVersion'])

      this.versions = convertToArrayModels(data.versions, AgreementsDocumentVersion)
      this.actualVersion
        = convertToModel(data.actual_version, AgreementsDocumentVersion)
          ?? (this.versions.find(version => version.isActual) ?? null)
    }
  }
}

registerModel(AgreementsDocument)
